import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export type ModuleAffectation = 'POULAILLER' | 'BASSINS' | 'CHEPTEL' | 'CULTURES';

export const MODULES_AFFECTATION: { code: ModuleAffectation; libelle: string; icone: string }[] = [
  { code: 'POULAILLER', libelle: 'Poulailler', icone: 'egg_alt' },
  { code: 'BASSINS', libelle: 'Bassins', icone: 'water' },
  { code: 'CHEPTEL', libelle: 'Cheptel', icone: 'pets' },
  { code: 'CULTURES', libelle: 'Cultures', icone: 'agriculture' },
];

export interface AffectationPersonnel { uid: string; modules: ModuleAffectation[]; nom?: string; modifieLe?: string; modifiePar?: string; }

/** Affectations du Personnel (Poulailler, Bassins, Cheptel, Cultures) */
@Injectable({ providedIn: 'root' })
export class AffectationService {

  private readonly base = `${environment.BASE_URL}/api/tenant/users`;
  /** Mes affectations (via /api/me) ; liste vide = aucune restriction de menu */
  readonly mesModules$ = new BehaviorSubject<ModuleAffectation[]>([]);
  private charge = false;

  constructor(private http: HttpClient) {}

  liste(): Observable<AffectationPersonnel[]> {
    return this.http.get<AffectationPersonnel[]>(`${this.base}/affectations`);
  }

  definir(uid: string, nom: string, modules: ModuleAffectation[]): Observable<AffectationPersonnel> {
    return this.http.put<AffectationPersonnel>(`${this.base}/${uid}/affectations`, { nom, modules });
  }

  /** Charge mes affectations une fois par session (sans effet si /api/me est indisponible) */
  chargerMesModules(): void {
    if (this.charge) { return; }
    this.charge = true;
    this.http.get<any>(`${environment.BASE_URL}/api/me`).pipe(
      tap(r => {
        // Périmètre du gestionnaire (FERME : toute la ferme ; MODULES : limité à ses postes), lu par RoleUtil
        try {
          sessionStorage.setItem('perimetre', r?.utilisateur?.perimetre || 'FERME');
          sessionStorage.setItem('postes', JSON.stringify(r?.utilisateur?.affectations || []));
        } catch { /* stockage indisponible : périmètre ferme par défaut */ }
      }),
      map(r => (r?.utilisateur?.affectations || []) as ModuleAffectation[]),
      catchError(() => of([] as ModuleAffectation[])),
      tap(m => this.mesModules$.next(m)),
    ).subscribe();
  }
}
